import React, { useState, useEffect, useRef } from 'react';
import { useParams, Routes, Route } from 'react-router-dom';
import { navigationContext } from '../../context';
import GlobalStyle from '../../style/globalStyle';
import Home from '../../pages/home/home';
import { getHelioDatas } from '../../utils/getHelioDatas';
import FullScreen from '../../layout/fullScreen/fullScreen';

const HelioRouter = () => {

    const { helioUrl } = useParams();
    const [helio, setHelio] = useState(null);
    const [helioDatas, setHelioDatas] = useState(null);

    // Récuperation du nom de helio a partir de l'url

    useEffect(() => {
        setHelio(helioUrl)
    }, [helioUrl])

    // Fetch des données helio
    useEffect(() => {

        if (helio) {
            getHelioDatas(helio).then(
                datas =>
                    setHelioDatas(datas)
            )
        }
    }, [helio])

    return (
        <navigationContext.Provider value={{
            helio: helio,
            setHelio: setHelio,
            helioDatas: helioDatas,
            setHelioDatas: setHelioDatas,
        }}>

            <GlobalStyle />

            {helioDatas &&
                <Routes>
                    <Route path="" element={<Home />} />
                    <Route path="/:helioUrl/:selectedDate/:selectedView" element={<Home />} />
                </Routes>
            }

            <div id="mobile-warning">
                <div id="mobile-preview"></div>
                <p>Pour profiter pleinement de l'expérience, tournez votre téléphone et passez en plein écran</p>
            </div>

            <div id='mobile-test'>
                    <FullScreen />
            </div>

        </navigationContext.Provider>
    )
}

export default HelioRouter;